import styles from "../surveyors/mantenedor_surveyor.module.css";
import {Link} from "react-router-dom";
import stylesFiltro from "../../home/ultimos_casos_reclamados/filtros.module.css";
import {FiltroCobro} from "./FiltroCobro";
import React, {useContext, useState} from "react";
import {TableCobro} from "./TableCobro";
import LangContext from "../../../context/LangContext";


export const OrdenCobro = ({setRouteActive}) => {

    const {traduccion} = useContext(LangContext);

    const [searchUrl, setSearchUrl] = useState(null);

    const searchClaims = (url) => {
        setSearchUrl(url)
    };

    const goToStart = () => {
        setRouteActive("/")
    }

    return (
        <div className={styles.all_surveyor}>
            <div className={styles.breadcrumb}>
                {traduccion?.breadcrumb?.uRin}
                <Link className={styles.like_a} to={"/"}>
                    <span onClick={goToStart}>{traduccion?.breadcrumb?.home}</span>
                </Link>>
                <span className={styles.bold}>{traduccion?.ordenCobro?.ordCobro}</span>
            </div>
            <>
                <p className={stylesFiltro.title_claimed}
                   style={{marginLeft: '0rem'}}>{traduccion?.ordenCobro?.ordCobro}</p>
                <FiltroCobro searchClaims={searchClaims}/>
                <TableCobro searchUrl={searchUrl}/>
            </>
        </div>
    );
}
